import React from 'react'

import { Alert, Box, Icon, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Warning = ({ message }: { message?: string }) => {
  return (
    <Alert color="warning">
      <Box flexDirection="row" gap="s8">
        <Icon.Medium icon="alert-circle" color="grey800" />
        <Text.Normal color="grey1000" whiteSpace="breakSpaces">
          {message || i18n.t('tasks.types.data_collection.details.forbidden_message')}
        </Text.Normal>
      </Box>
    </Alert>
  )
}

export default Warning
